import axiosInstance from "../config/axiosInterceptor";

export async function getRegionSaleReports() {
  return await axiosInstance.get("/api/VednaiRegionSaleReport/GetRegionSaleReports");
}
